import { IsoLocale } from "@izettle/constants"

import { RequirementType } from "../generic-document-upload"

type InstructionKeys = {
  title: string
  introTextSingle?: string
  introTextMultiple: string
  listTitle: string
  listItems: Map<IsoLocale, string[]>
  footNote?: Map<IsoLocale, string>
}

export type InstructionsKeys = {
  proofOfBusiness: InstructionKeys
  visaResidentPermit: InstructionKeys
  proofOfIdUBO: InstructionKeys
  proofOfBusinessAddress: InstructionKeys
  contactSupport: InstructionKeys
  proofOfId : InstructionKeys
}

export type RequirementReasons =   "proofOfBusiness"
  | "visaResidentPermit"
  | "proofOfIdUBO"


export const instructionsKeys: InstructionsKeys = {
  proofOfBusiness: {
    title: "PROOF_OF_BUSINESS_TITLE",
    introTextSingle: "PROOF_OF_BUSINESS_INTRO_TEXT_SINGLE",
    introTextMultiple: "PROOF_OF_BUSINESS_INTRO_TEXT",
    listTitle: "",
    listItems: new Map([
      [
        IsoLocale.enGB,
        [
          "POB_UK_LIMITED_INSTRUCTION",
          "POB_UK_NPO_INSTRUCTION",
          "POB_UK_PARTNERSHIP_INSTRUCTION",
        ],
      ],
      [
        IsoLocale.deDE,
        [
          "BUSINESS_REGISTRATION",
          "COMMERCIAL_REGISTER_EXTRACT",
          "ASSOCIATION_REGISTER_EXTRACT",
          "PARTNERSHIP_REGISTER_EXTRACT",
          "COOPERATIVE_REGISTER_EXTRACT",
          "FOUNDING_PROTOCOL",
          "STATUTE",
        ],
      ],
      [
        IsoLocale.frFR,
        ["SOLE_TRADER_FRANCE", "NON_PROFIT_FRANCE", "OTHER_COMPANIES_FRANCE"],
      ],
      [IsoLocale.nlNL, ["KVK_EXTRACT"]],
      [
        IsoLocale.svSE,
        [
          "REGISTER_EXTRACT_TAX_AGENCY",
          "REGISTER_EXTRACT_COMPANY_REGISTRATION_OFFICE",
          "MINUTES_ANNUAL_MEETING",
        ],
      ],
      [IsoLocale.nbNO, ["NO_POB_SOLE_TRADERS", "NO_POB_REGISTERED_COMPANIES"]],
      [IsoLocale.daDK, ["DK_POB_NON_PROFITS", "DK_POB_ALL_COMPANY_TYPES"]],
      [IsoLocale.fiFI, ["FI_POB_SOLE_TRADERS", "FI_POB_LIMITED", "FI_POB_NON_PROFIT"]],
      [IsoLocale.svFI, ["FI_POB_SOLE_TRADERS", "FI_POB_LIMITED", "FI_POB_NON_PROFIT"]],
      [IsoLocale.esES, ["ES_POB_ALL_COMPANY_TYPES", "ES_POB_NON_PROFITS"]],
      [
        IsoLocale.itIT,
        ["IT_POB_LTD_AND_PARTNERSHIPS", "IT_POB_SOLE_TRADERS", "IT_POB_NON_PROFITS"],
      ],
      [IsoLocale.esMX, ["CONSTANCIA_SITUACION_FISCAL"]],
    ]),
    footNote: new Map([
      [IsoLocale.nlNL, "PROOF_OF_BUSINESS_FOOT_NOTE_NL"],
      [IsoLocale.nbNO, "PROOF_OF_BUSINESS_FOOT_NOTE"],
    ]),
  },
  proofOfBusinessAddress: {
    title: "PROOF_OF_BUSINESS_ADDRESS_TITLE",
    introTextSingle: "",
    introTextMultiple: "PROOF_OF_BUSINESS_ADDRESS_INTRO_TEXT",
    listTitle: "",
    listItems: new Map([[IsoLocale.esMX, ["ENERGY_BILL", "PROPERTY_TAX_BILL"]]]),
    footNote: new Map([[IsoLocale.esMX, "PROOF_OF_BUSINESS_ADDRESS_FOOT_NOTE_MX"]]),
  },
  visaResidentPermit: {
    title: "RESIDENCE_PERMIT_TITLE",
    introTextSingle: "RESIDENCE_PERMIT_INTRO_TEXT",
    introTextMultiple: "RESIDENCE_PERMIT_INTRO_TEXT_MULTIPLE",
    listTitle: "",
    listItems: new Map([
      [IsoLocale.enGB, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.deDE, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.frFR, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.nlNL, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.svSE, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.nbNO, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.daDK, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.fiFI, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.svFI, ["VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.esES, ["ES_VISA_RESIDENCE_PERMIT"]],
      [IsoLocale.itIT, ["VISA_RESIDENCE_PERMIT"]],
    ]),
  },
  proofOfIdUBO: {
    title: "ID_UBO_TITLE",
    introTextMultiple: "ID_UBO_INTRO_SINGLE_DOCUMENT_TEXT",
    listTitle: "ID_UBO_LIST_TITLE",
    listItems: new Map([
      [
        IsoLocale.enGB,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.deDE,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.frFR,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE_FRANCE",
        ],
      ],
      [
        IsoLocale.nlNL,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.svSE,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.nbNO,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [IsoLocale.daDK, ["ID_UBO_PASSPORT", "ID_UBO_DRIVING_LICENSE"]],
      [
        IsoLocale.fiFI,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.svFI,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.esES,
        [
          "ID_UBO_PASSPORT",
          "ID_UBO_NATIONAL_ID_FRONT_AND_BACK",
          "ID_UBO_DRIVING_LICENSE",
        ],
      ],
      [
        IsoLocale.itIT,
        ["IT_ID_UBO_NATIONAL_ID_PICTURE", "ID_UBO_PASSPORT", "ID_UBO_DRIVING_LICENSE"],
      ],
    ]),
  },
  contactSupport: {
    title: "CONTACT_SUPPORT_TITLE",
    introTextMultiple: "CONTACT_SUPPORT_INTRO_TEXT",
    listTitle: "CONTACT_SUPPORT_LIST_TITLE",
    listItems: new Map([
      [IsoLocale.enGB, []],
      [IsoLocale.deDE, []],
      [IsoLocale.frFR, []],
      [IsoLocale.nlNL, []],
      [IsoLocale.svSE, []],
      [IsoLocale.nbNO, []],
      [IsoLocale.daDK, []],
      [IsoLocale.fiFI, []],
      [IsoLocale.svFI, []],
      [IsoLocale.esES, []],
      [IsoLocale.itIT, []],
      [IsoLocale.esMX, []],
    ]),
  },
  proofOfId: {
    title: "PROOF_OF_ID_TITLE_MX",
    introTextSingle: "",
    introTextMultiple: "",
    listTitle: "",
    listItems: new Map(),
    footNote: new Map(),
  },
}

export const getIntroText = (requirementType: RequirementType, locale: IsoLocale) => {
  const instructionKeys = instructionsKeys[requirementType]
  const listItems = instructionKeys.listItems.get(locale) ?? []

  return listItems.length === 1 && instructionKeys.introTextSingle
    ? instructionKeys.introTextSingle
    : instructionKeys.introTextMultiple
}

export const getFootNote = (requirementType: RequirementType, locale: IsoLocale) => {
  return instructionsKeys[requirementType]?.footNote?.get(locale) ?? ""
}

export const customInstructionKeyValue : any = {
  proofOfBusiness : { errorKey : 'BANK_STATEMENT_MISSING', translationKey : 'BANK_STATEMENT_MISSING_INSTRUCTION' },
  proofOfId : { errorKey : 'PROOF_OF_ID', translationKey : 'PROOF_OF_ID_INSTRUCTION' },
  proofOfIdUBO : { errorKey : 'BANK_STATEMENT_MISSING', translationKey : 'BANK_STATEMENT_MISSING_INSTRUCTION' }
}
